import React from 'react';
import Box from '@mui/material/Box';
import InsertDriveFile from '@raisin/components-lib/Icons/InsertDriveFile';
import { DBSProduct } from 'types';
import * as S from './styles';

interface DocumentLinkProps {
  offer: DBSProduct;
}
const PRODUCT_INFO_SHEET_DOC_TYPE = 'PRODUCT_INFORMATION_SHEET';
const SUSTAINABILITY_INFO_SHEET_DOC_TYPE = 'SUSTAINABILITY_INFORMATION_SHEET';

const DocumentLink: React.FC<DocumentLinkProps> = ({ offer }) => {
  const documents = offer?.pre_contractual_documents?.filter((doc) =>
    [PRODUCT_INFO_SHEET_DOC_TYPE, SUSTAINABILITY_INFO_SHEET_DOC_TYPE].includes(doc?.document_type),
  );

  return (
    <>
      {documents.map((doc) => (
        <Box display="flex" key={doc?.document_type} my={1}>
          <S.Button
            href={doc?.url}
            target="_blank"
            mode="primaryText"
            startIcon={<InsertDriveFile />}
            data-testid={doc?.document_type}
          >
            <span>{doc?.display_name}</span>
          </S.Button>
        </Box>
      ))}
    </>
  );
};

export default DocumentLink;
